import { zeroFillBuckets } from '@/lib/analytics/buckets';
import type { Granularity } from '@/lib/analytics/metrics';
import type { SeriesConfig } from '@/lib/analytics/seriesConfig';
import type { TimeSeriesResult } from '@/hooks/useTimeseriesQuery';

export type ChartRow = Record<string, string | number>;

// Builds the chart's data array spanning the user-selected [from, to] period.
// The date axis is generated from from/to so the chart always extends to the
// period boundaries even when individual series report partial or empty data.
// Per-series values are overlaid where present and default to 0 elsewhere.
export function buildMergedChartData(
  from: Date,
  to: Date,
  granularity: Granularity,
  series: ReadonlyArray<SeriesConfig>,
  seriesData: Record<string, TimeSeriesResult>,
): ChartRow[] {
  const dateAxis = zeroFillBuckets([], from, to, granularity).map((b) => b.bucket_date);
  const lookups = new Map<string, Map<string, number>>();
  for (const s of series) {
    const buckets = seriesData[s.id]?.buckets;
    if (!buckets) continue;
    const m = new Map<string, number>();
    for (const b of buckets) m.set(b.bucket_date, b.current);
    lookups.set(s.id, m);
  }
  return dateAxis.map((date) => {
    const row: ChartRow = { bucket_date: date };
    for (const s of series) row[s.id] = lookups.get(s.id)?.get(date) ?? 0;
    return row;
  });
}
